export { default as defaultMantineTheme } from './defaultMantineTheme'
